import { makeStyles } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import { useEffect, useState } from "react";
import { Button, useMutation, useNotify } from "react-admin";
import { useFormState } from "react-final-form";
import { useHistory } from "react-router-dom";

interface ISaveRoutePlanButton {
  isSaveLoading: (x: boolean) => void;
}

const useStyles = makeStyles({
  savePlanButton: {
    padding: "8px",
    float: "right",
    minWidth: "10px",
    "& .MuiButton-textSizeSmall": {
      padding: 0,
    },
    "& .MuiButton-label > .MuiSvgIcon-root": {
      fontSize: 25,
    },
  },
});

const SaveRoutePlanButton = ({ isSaveLoading }: ISaveRoutePlanButton) => {
  const [isDisable, setIsDisable] = useState<boolean>(true);

  const classes = useStyles();
  const { values } = useFormState();
  const notify = useNotify();
  const history = useHistory();

  useEffect(() => {
    if (values?.busScheduleId) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const [saveRoutePlan, { loading }] = useMutation(
    {
      type: "create",
      resource: "busSchedulePlans",
      payload: {
        data: values,
      },
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully create the route plan.`, "info");
        history.push(`/busSchedulePlans/${data.id}`);
      },
      onFailure: (error) => {
        notify(
          `Failed create the route plan, error: ${error.message}`,
          "warning"
        );
      },
    }
  );

  useEffect(() => {
    isSaveLoading(loading);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  return (
    <Button
      className={classes.savePlanButton}
      onClick={saveRoutePlan}
      disabled={isDisable}
    >
      <SaveIcon />
    </Button>
  );
};

export default SaveRoutePlanButton;
